export default "__VITE_ASSET__BBzkirfI__"